module.exports = ".col-login {\r\n    max-width: 35rem !important;\r\n}"